import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { GLOBALS } from 'services/globals';

import EnhancedPersonalServiceBenefits from 'components/layouts/Preferences/Benefits/EnhancedPersonalServiceBenefits';
import PersonalServiceBenefits from 'components/layouts/Preferences/Benefits/PersonalServiceBenefits';
import CoreBenefits from 'components/layouts/Preferences/Benefits/CoreBenefits';
import { getView } from 'state/view/ViewSelectors';

import {
  SERVICE_TYPE_CORE,
  SERVICE_TYPE_MIL,
  SERVICE_TYPE_HNW
} from 'services/ServiceBenefits';
import {non529OnlyLRNTaxesDashboardAccountsBenefits} from 'services/FeatureFlags';
import LegalReferenceNumber from 'components/layouts/LegalReferenceNumber/LegalReferenceNumber';

const epsRedirect = '/enhanced-personal-services-benefits';
const psRedirect = '/personal-services-benefits';
const coreRedirect = '/client-services-benefits';

const BenefitsRedirect = ({ path, redirect, defaultLocation }) => (
  <Fragment>
    {path !== GLOBALS.AAM_UI_TRP_APP_CONTEXT + redirect ? (
      <Redirect to={redirect} />
    ) : (
      defaultLocation
    )}
  </Fragment>
);

const Benefits = ({ serviceType, view }) => (
  <Fragment>
    {serviceType === SERVICE_TYPE_MIL && (
      <BenefitsRedirect
        path={location.pathname}
        redirect={epsRedirect}
        defaultLocation={<EnhancedPersonalServiceBenefits />}
      />
    )}
    {serviceType === SERVICE_TYPE_HNW && (
      <BenefitsRedirect
        path={location.pathname}
        redirect={psRedirect}
        defaultLocation={<PersonalServiceBenefits />}
      />
    )}
    {(serviceType === SERVICE_TYPE_CORE || serviceType === null) && (
      <BenefitsRedirect
        path={location.pathname}
        redirect={coreRedirect}
        defaultLocation={<CoreBenefits view={view} />}
      />
    )}
    {non529OnlyLRNTaxesDashboardAccountsBenefits() && (
        <LegalReferenceNumber />
    )}
  </Fragment>
);

const mapStateToProps = (state) => ({
  serviceType: state.customer.serviceType,
  view: getView(state),
});

export default connect(mapStateToProps)(Benefits);
